import React from 'react';
import { LanguagesIcon, CheckCircle2Icon } from 'lucide-react';
export function MultilingualCallout() {
  return <section className="py-16 bg-slate-900 text-white" data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10" data-id="element-217">
          <div className="md:w-1/2" data-id="element-218">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-white/10 mb-6" data-id="element-219">
              <LanguagesIcon className="w-6 h-6 text-accent" data-id="element-220" />
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-221">
              Inclusive Multilingual Support
            </h3>
            <p className="text-slate-300 text-lg mb-6 leading-relaxed" data-id="element-222">
              ERPLogiFlow currently supports announcements in both Nepali and
              English, allowing organizations to provide a more inclusive and
              customer-friendly experience based on their audience.
            </p>
            <ul className="space-y-3" data-id="element-223">
              <li className="flex items-center gap-3 text-slate-300" data-id="element-224">
                <CheckCircle2Icon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-225" />
                <span data-id="element-226">Clear communication for diverse customer groups</span>
              </li>
              <li className="flex items-center gap-3 text-slate-300" data-id="element-227">
                <CheckCircle2Icon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-228" />
                <span data-id="element-229">Reduces confusion in the waiting area</span>
              </li>
              <li className="flex items-center gap-3 text-slate-300" data-id="element-230">
                <CheckCircle2Icon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-231" />
                <span data-id="element-232">Enhances accessibility for all visitors</span>
              </li>
            </ul>
          </div>

          <div className="md:w-5/12 w-full" data-id="element-233">
            <div className="bg-slate-800 rounded-2xl p-8 border border-slate-700 shadow-xl relative overflow-hidden" data-id="element-234">
              <div className="absolute top-0 right-0 w-32 h-32 bg-accent/10 rounded-full blur-3xl" data-id="element-235"></div>
              <div className="space-y-6 relative z-10" data-id="element-236">
                <div className="bg-slate-900/50 rounded-lg p-5 border border-slate-700" data-id="element-237">
                  <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2" data-id="element-238">
                    English
                  </div>
                  <div className="text-lg font-medium" data-id="element-239">
                    "Mr. Rajesh Kumar, please proceed to the Loan Department."
                  </div>
                </div>
                <div className="bg-slate-900/50 rounded-lg p-5 border border-slate-700" data-id="element-240">
                  <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2" data-id="element-241">
                    नेपाली
                  </div>
                  <div className="text-lg font-medium" data-id="element-242">
                    "श्री राजेश कुमार, कृपया ऋण विभागमा जानुहोस्।"
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}